const LOCALE = 'en-US';

/**
 * @param amount: ex: 1234.56
 * @returns: string: USD with no decimal places, ex: "$1,235"
 */
export const formatCurrency = (amount: number): string =>
  new Intl.NumberFormat(LOCALE, {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);

/**
 * @param amount: ex: 1234.5
 * @returns: string: USD preserving real cents, dropping a trailing ".00", ex: "$1,234.50" / "$1,234"
 */
export const formatCurrencyWithCents = (amount?: number | null): string => {
  const value = amount ?? 0;
  return new Intl.NumberFormat(LOCALE, {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: Number.isInteger(value) ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(value);
};

/**
 * @param value: ex: 1234
 * @returns: string: whole number with thousands separators, ex: "1,234"
 */
export const formatCount = (value: number): string =>
  new Intl.NumberFormat(LOCALE, { maximumFractionDigits: 0 }).format(value);

/**
 * @param hours: ex: 4.5
 * @returns: string: one decimal place, dropping a trailing ".0", ex: "4.5" / "877"
 */
export const formatHours = (hours: number): string =>
  new Intl.NumberFormat(LOCALE, {
    maximumFractionDigits: Number.isInteger(hours) ? 0 : 1,
  }).format(hours);
